/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { pdfControllerGeneratePdf } from '../fn/pdf/pdf-controller-generate-pdf';
import { PdfControllerGeneratePdf$Params } from '../fn/pdf/pdf-controller-generate-pdf';
import { pdfControllerGeneratePdfUrl } from '../fn/pdf/pdf-controller-generate-pdf-url';
import { PdfControllerGeneratePdfUrl$Params } from '../fn/pdf/pdf-controller-generate-pdf-url';
import { PdfUrlDto } from '../models/pdf-url-dto';

@Injectable({ providedIn: 'root' })
export class PdfService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pdfControllerGeneratePdf()` */
  static readonly PdfControllerGeneratePdfPath = '/api/pdf';

  /**
   * PDF 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pdfControllerGeneratePdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  pdfControllerGeneratePdf$Response(params: PdfControllerGeneratePdf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pdfControllerGeneratePdf(this.http, this.rootUrl, params, context);
  }

  /**
   * PDF 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pdfControllerGeneratePdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pdfControllerGeneratePdf(params: PdfControllerGeneratePdf$Params, context?: HttpContext): Observable<void> {
    return this.pdfControllerGeneratePdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pdfControllerGeneratePdfUrl()` */
  static readonly PdfControllerGeneratePdfUrlPath = '/api/pdf/generate-url';

  /**
   * PDF URL 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pdfControllerGeneratePdfUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  pdfControllerGeneratePdfUrl$Response(params: PdfControllerGeneratePdfUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<PdfUrlDto>> {
    return pdfControllerGeneratePdfUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * PDF URL 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pdfControllerGeneratePdfUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pdfControllerGeneratePdfUrl(params: PdfControllerGeneratePdfUrl$Params, context?: HttpContext): Observable<PdfUrlDto> {
    return this.pdfControllerGeneratePdfUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<PdfUrlDto>): PdfUrlDto => r.body)
    );
  }

}
